import { INSTAPRO_BASE_URL } from "@/constants/util"
import { paramsSerializer } from "@/utils/api.utils"
import axios from "axios"

// DEPRECATED. Use fetchCoaches instead
export const fetchCoachUsers = async ({ filters, page }) => {
  try {
    const url = `${INSTAPRO_BASE_URL}coach`
    const config = {
      params: { filters, page },
      paramsSerializer,
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const fetchCoaches = async ({ games, filters, categories, sort, search, page }) => {
  try {
    const url = `${INSTAPRO_BASE_URL}coaches`
    const config = {
      params: { games, filters, categories, sort, search, page },
      paramsSerializer,
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}



// WEBPACK FOOTER //
// ./src/store/coaching/coaching.apis.js